export default __webpack_public_path__ + "static/media/porfirio2.366bb3c9.jpg";